import { useQuery, useQueryClient, useMutation } from 'react-query'
import client, { deleteclient, patchclient } from './api-client';

const parcelQueryConfig = {
  staleTime: 1000 * 60 * 60,
  cacheTime: 1000 * 60 * 60,
}

async function fetchCrops(parcel) {
  const data = await client(`crops/?parcel=${parcel.id}`)
  return data
}

export function useCrops(parcel) {
  return useQuery(['crops'], () => fetchCrops(parcel), {
    refetchAllOnWindowFocus: false,
    ...parcelQueryConfig
  });
}

async function addCrop(request) {
  await client('crops/', { body: request })
}

export function useAddCropMutation(request) {
  const queryClient = useQueryClient();

  return useMutation((request) => addCrop(request), );
}


async function deleteCrop(id) {
  await deleteclient(`crops/${id}/`)
}

export function useDeleteCropMutation(id) {
  const queryClient = useQueryClient();

  return useMutation((id) => deleteCrop(id), {
      onSuccess: (data, variables) => {
          queryClient.invalidateQueries(['crops'])
      },
  });
}



async function updateCrop(request) {
  await patchclient(`crops/${request.id}/`, { body: request })
}

export function useUpdateCropMutation(request) {
  const queryClient = useQueryClient();

  return useMutation((request) => updateCrop(request));
}